import Backbone from 'backbone';

export const BillingListCollection = Backbone.Collection.extend({

	initialize: function() {
		this.channel = Backbone.Radio.channel( 'AppChannel' );
		this.app = this.channel.request( 'app' );
	},

});